// src/ContactUs.js

import React, { useState } from "react";
import axios from "axios";
import "./css/ContactUs.css"; // Import the corresponding CSS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons"; // Optional: Icon for the button

const API_URL =
  "https://zx6jxjugm7.execute-api.us-east-2.amazonaws.com/default/ContactUs"; // Replace with your actual API endpoint

const ContactUs = () => {
  // State variables for form fields
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  // State variables for handling submission status
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null); // 'success' or 'error'

  // State variable for form validation errors
  const [errors, setErrors] = useState({});

  // Function to validate form fields
  const validate = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email.trim())) {
      newErrors.email = "Invalid email address.";
    }

    if (!message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);
    setSubmissionStatus(null);

    try {
      // Send POST request to the API
      const response = await axios.post(API_URL, {
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
      });

      if (response.status === 200) {
        setSubmissionStatus("success");
        // Clear form fields
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setSubmissionStatus("error");
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      setSubmissionStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us-container">
      <h2>Contact Us</h2>

      {/* Success Message */}
      {submissionStatus === "success" && (
        <div className="success-message">
          Thank you! Your message has been sent successfully.
        </div>
      )}

      {/* Error Message */}
      {submissionStatus === "error" && (
        <div className="error-message">
          Oops! Something went wrong. Please try again later.
        </div>
      )}

      <form onSubmit={handleSubmit} noValidate>
        {/* Name Field */}
        <div className="form-group">
          <label htmlFor="name">
            Name<span className="required">*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={errors.name ? "input-error" : ""}
            disabled={isSubmitting}
            placeholder="Enter your name"
          />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        {/* Email Field */}
        <div className="form-group">
          <label htmlFor="email">
            Email<span className="required">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={errors.email ? "input-error" : ""}
            disabled={isSubmitting}
            placeholder="Enter your email"
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>

        {/* Message Field */}
        <div className="form-group">
          <label htmlFor="message">
            Message<span className="required">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            rows="5"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className={errors.message ? "input-error" : ""}
            disabled={isSubmitting}
            placeholder="Enter your message"
          ></textarea>
          {errors.message && (
            <span className="error-text">{errors.message}</span>
          )}
        </div>

        {/* Submit Button */}
        <button type="submit" className="submit-form" disabled={isSubmitting}>
          {isSubmitting ? (
            "Sending..."
          ) : (
            <>
              Send Message <FontAwesomeIcon icon={faPaperPlane} />
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
